const resolveApiUrl = (path) => {
  const normalizedPath = path.startsWith("/") ? path : `/${path}`;

  if (typeof window === "undefined") return normalizedPath;

  const { hostname, port, protocol } = window.location;
  const isLocalHost = hostname === "localhost" || hostname === "127.0.0.1" || hostname === "::1" || hostname === "[::1]";
  const isLocalGatsbyPort = isLocalHost && port === "8000";

  if (process.env.NODE_ENV === "development" && isLocalGatsbyPort) {
    return `${protocol}//${hostname}:8000${normalizedPath}`;
  }

  return normalizedPath;
};

export { resolveApiUrl };
